import { connect, ConnectedProps } from 'react-redux'
import { ComponentWithPermissions } from '../../../../../../../../../baseComponents/CreateRoutering/types'
import LoaderDecider from '../../../../../../../../../baseComponents/LoaderDecider'
import TwinForm from '../../../../../../../../../forms/TwinForm'
import withLoading from '../../../../../../../../../utils/hoc/withLoading'
import useIsLoading from '../../../../../../../../../utils/hooks/useIsLoading'
import useLangData from '../../../../../../../../../utils/hooks/useLangData'
import { AllReduxPayloads } from '../../../../../../../../../utils/reducers'
import { GroupVatPayload } from '../../../../../../../../../utils/reducers/globals/groupVats'
import { BrandsPayload } from '../../../../../../../../../utils/reducers/products/brands'
import { ProductLayoutWithDelete } from '../../../../../../../../../specificComponents/Product/ProductLayout'
import DefaultMainLeftProductLayout from '../../../../../../../../../specificComponents/Product/ProductLayout/LeftSide/DefaultMainLeftProductLayout'
import DefaultMainRightProductLayout from '../../../../../../../../../specificComponents/Product/ProductLayout/RightSide/DefaultMainRightProductLayout'
import { ProductExtendedTyShort } from '../../../../../../../../../specificComponents/Product/types'
import { CollectionsPayload } from '../../../../../../../../../utils/reducers/products/collections'

interface MainProductProps extends ComponentWithPermissions {
    basicData: ProductExtendedTyShort
    getData: () => Promise<void>
}

const MainProduct: React.FC<MainProductProps & ReduxProducts> = ({ basicData, getData, userPermissions }) => {
    const langData = useLangData({ myData: basicData?.ProductLangs, fieldsToLang: ['name', 'shortDescription', 'description', 'descriptionDocuments', 'shortDescriptionDocuments'], keyValue: 'LangId' })
    const { startLoading, endLoading, loading } = useIsLoading()
    return (
        <TwinForm className='flex flex-auto h-1' action='/api/app/product/updateProduct' imagepath={['product', String(basicData?.id)]} onSubmit={() => { endLoading(); getData() }} beforeSubmitHandler={startLoading} onError={endLoading} >
            <LoaderDecider loading={langData.data ? false : true}>
                <ProductLayoutWithDelete basicData={basicData} userPermissions={userPermissions} buttonIsDisabled={loading} locationPath='products' getData={getData}>
                    <div className='product_container flex flex-wrap'>
                        <DefaultMainLeftProductLayout {...{ ...langData, basicData, getData, userPermissions, data: langData.data || {} }}/>
                        <DefaultMainRightProductLayout {...{basicData, userPermissions, changeLang: langData.changeLang, selectedLang: langData.selectedLang}} />
                    </div>
                </ProductLayoutWithDelete>
            </LoaderDecider>
        </TwinForm >
    )
}

const productDispatch = {
    setGroupVats: (payload: GroupVatPayload) => ({ type: 'CHANGE_GROUPVAT', payload }),
    setBrands: (payload: BrandsPayload) => ({ type: 'CHANGE_BRANDS', payload }),
    setCollections: (payload: CollectionsPayload) => ({ type: 'CHANGE_COLLECTIONS', payload }),
}

const mapProductConnect = (state: AllReduxPayloads) => ({ groupVats: state.groupVats, brands: state.brands, collections: state.collections })
const productConnect = connect(mapProductConnect, productDispatch)
export type ReduxProducts = ConnectedProps<typeof productConnect>

const productConnectLoading = withLoading(MainProduct, [
    { fetchUrl: '/api/app/config/vat/getAllGroupsVat', propName: 'groupVats', setFunctionName: 'setGroupVats' },
    { fetchUrl: '/api/app/product/brand/getAllBrands', propName: 'brands', setFunctionName: 'setBrands' },
    { fetchUrl: '/api/app/product/collection/getAllCollections', propName: 'collections', setFunctionName: 'setCollections' }
])
const MainProductConnect = productConnect(productConnectLoading)

export default MainProductConnect